export default __webpack_public_path__ + "static/media/Feature5.17c57325.svg";